import React, { memo } from "react";

import { Button } from "@/common/components";

type PresentationLinkProps = {
  href?: string;
  children?: React.ReactNode;
  classNameBtn?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
};

const PresentationLink: React.FC<PresentationLinkProps> = memo(
  ({
    href = "/Презентация_ЭИС.pdf",
    children = "Посмотреть презентацию",
    classNameBtn = "",
    target = "_blank",
  }) => {
    const handleOpenPresentation = () => {
      window.open(href, target);
    };
    return (
      <Button variant="outline" className={classNameBtn} onClick={handleOpenPresentation}>
        {children}
      </Button>
    );
  },
);

export { PresentationLink };
